import { Component, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

import { MappingService } from '@services/mapping.service';
import { MappingTree } from '@classes/mapping/mapping-tree';
import { MappingStructure } from '@classes/mapping/mapping-structure';

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnChanges {
    @Input() canEditMapping: boolean;
    @Input() structure: MappingStructure[] = [];
    @Input() depsLabel: string;
    @Input() displayValidity: boolean;

    tree: MappingTree[] = []

    filterForm: UntypedFormGroup;

    constructor(
        private fb: UntypedFormBuilder,
        private mappingSrv: MappingService
    ) { }

    ngOnChanges(): void {
        this.tree = this.initTreeNodes();
        this.initForm();
    }

    onTreeChanged(tree: MappingTree[]): void {
        this.tree = tree;
        this.mappingSrv.treeChanged.next(tree);
    }

    private initTreeNodes(tree?: MappingStructure[]): MappingTree[] {
        let isRoot = false;

        if (!tree) {
            const rootTree = new MappingTree('root', '', 0);
            rootTree.children = this.structure;
            isRoot = true;
            tree = [rootTree];
        }

        return tree.map(item =>
            Object.assign(new MappingTree(), {
                ...item,
                isOpen: isRoot,
                children: item.children ? this.initTreeNodes(item.children as MappingStructure[]) : []
            })
        );
    }

    private initForm(): void {
        this.filterForm = this.fb.group({
            filter: ['']
        });

        this.filterForm.controls.filter.valueChanges
            .subscribe((value: string) => {
                this.filterTree(this.tree, value.trim().toLowerCase());
            });
    }

    private filterTree(items: MappingTree[], filterValue: string): boolean {
        if (items && items.length === 0) {
            return false;
        }

        items.map(item => {
            const hasVisibleChildren = this.filterTree(item.children as MappingTree[], filterValue);
            item.isVisible = hasVisibleChildren
                || filterValue === ''
                || filterValue == null
                || item.label.toLowerCase().includes(filterValue)
                || item.dependencies.some(c => c.code.toLowerCase().includes(filterValue));
            if (item.label === 'root') {
                item.isOpen = true;
            } else {
                item.isOpen = filterValue ? hasVisibleChildren : false;
            }
            item.isEditMode = false;
        });

        return items.some(i => i.isVisible);
    }
}
